export default class Tco {

  constructor(public vehiclePrice: number, public discounts: number, public fuel: number, public maintenance: number,
              public residualValue: number, public batteryResidualValue: number, public insurance: number, public patent: number,
              public infrastructure: number, public annualFuelCosts: number[], public annualMaintenanceCosts: number[],
              public annualInsuranceCosts: number[], public annualPatentCosts: number[]) {
  }

  getTCO(): number {
    return this.getTCOWithoutDiscounts() - this.getDiscountsAndResidualValue();
  }

  getTCOWithoutDiscounts(): number {
    return this.vehiclePrice + this.fuel + this.maintenance + this.insurance + this.patent + this.infrastructure;
  }

  getTCOWithResidualValues(): number {
    return this.getTCOWithoutDiscounts() - this.getResidualValue();
  }

  getTCOWithDiscounts(): number {
    return this.getTCOWithoutDiscounts() - this.discounts;
  }

  getDiscountsAndResidualValue(): number {
    return this.discounts + this.getResidualValue();
  }

  getResidualValue(): number {
    return this.residualValue + this.batteryResidualValue;
  }
}
